import { render, staticRenderFns } from "./PlaylistsSelectModal.vue?vue&type=template&id=8e45f168&"
import script from "./PlaylistsSelectModal.vue?vue&type=script&lang=ts&"
export * from "./PlaylistsSelectModal.vue?vue&type=script&lang=ts&"
import style0 from "./PlaylistsSelectModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports